import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrlApi } from "../../proxy";
/*--------------------------GET ALL NEWS---------------------------*/
export const getAllNews = createAsyncThunk(
  "news/get-news",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}news`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
export const getNewsDetails = createAsyncThunk(
  "news/get-news-details",
  async (id: string) => {
    try {
      const response = await axios.get(`${baseUrlApi}news/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);
// get news category 
export const getNewsCategories = createAsyncThunk(
  "news/get-news-categories",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}news/category`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);